import { type AdminProfile, type UserPermissions, type UUID } from "@/core/types";
import { isCseProfile } from "@/core/helpers/(predicates)/adminProfile";
import { isLcsw } from "@/core/helpers/(predicates)/lcsw";

import { LcswPermissionCard } from "./LcswPermissionCard";

type LcswPermissionSelfProps = {
  permissions: Nullable<UserPermissions>;
  profileData: AdminProfile;
  userId: UUID;
};

// self-view: reflects the real is_lcsw status on a read-only switch — no can_grant_lcsw check
// needed since viewing your own status doesn't require grant privileges. Permissions are fetched
// by the parent so this stays presentational and covered by the page-level loader.
export function LcswPermissionSelf({ permissions, profileData, userId }: LcswPermissionSelfProps) {
  const isCse = isCseProfile(profileData);

  if (!isCse) return null;

  return (
    <LcswPermissionCard
      isLcsw={isLcsw(permissions)}
      isReadOnly
      userId={userId}
      userName={profileData.name}
    />
  );
}
